var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.25L18.8529 20.1029M18.8529 20.1029C18.9675 19.9884 19.0739 19.8658 19.1714 19.736C19.602 19.163 19.8571 18.4506 19.8571 17.6786C19.8571 15.785 18.3221 14.25 16.4286 14.25C14.535 14.25 13 15.785 13 17.6786C13 19.5721 14.535 21.1071 16.4286 21.1071C17.3753 21.1071 18.2325 20.7234 18.8529 20.1029Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.25H10.7273C7.46607 22.25 5.83546 22.25 4.70307 21.4522C4.37862 21.2236 4.09058 20.9525 3.8477 20.6471C3 19.5813 3 18.0466 3 14.9773V12.4318C3 9.46865 3 7.98706 3.46894 6.80375C4.22281 4.90142 5.81714 3.40088 7.83836 2.69135C9.09563 2.25 10.6698 2.25 13.8182 2.25C15.6173 2.25 16.5168 2.25 17.2352 2.5022C18.3902 2.90765 19.3012 3.7651 19.732 4.85214C20 5.52832 20 6.37494 20 8.06818V12.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.25C3 10.4091 4.49238 8.91667 6.33333 8.91667C6.99912 8.91667 7.78404 9.03333 8.43137 8.85988C9.00652 8.70576 9.45576 8.25652 9.60988 7.68136C9.78333 7.03404 9.66667 6.24912 9.66667 5.58333C9.66667 3.74238 11.1591 2.25 13 2.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaceholder);
export default __webpack_public_path__ + "static/media/icon-placeholder.c2bd7bb346bbf4c9ade4df12fdc40ef9.svg";
export { ForwardRef as ReactComponent };